import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { HashRouter} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import "@meridian/tokens/base/font/amazon-ember.css";
import {addLocaleData, IntlProvider} from "react-intl";
import de from 'react-intl/locale-data/de'
import en from 'react-intl/locale-data/en'
import es from 'react-intl/locale-data/es'
import fr from 'react-intl/locale-data/fr'
import hi from 'react-intl/locale-data/hi'
import it from 'react-intl/locale-data/it'
import ja from 'react-intl/locale-data/ja'
import pt from 'react-intl/locale-data/pt'
import ro from 'react-intl/locale-data/ro'

import App from "./components/App";
import {getLocale, getMessages} from "./components/handler/LocaleHandler";
import ErrorBoundary from "./components/ErrorBoundary";
import {pumaInit} from "./components/helper/PUMAMetricHelper";
import {parsePreferences} from "./components/utils/StorageUtil";

addLocaleData(de);
addLocaleData(en);
addLocaleData(es);
addLocaleData(fr);
addLocaleData(hi);
addLocaleData(it);
addLocaleData(ja);
addLocaleData(pt);
addLocaleData(ro);

/**
 * PUMA client detaches on window unload event. Ref: https://tiny.amazon.com/1iktrmp5v
 * We reinitialize PUMA client by listening on beforeunload event to avoid crash
 * due to metric emit when PUMA is not initialized.
 */
pumaInit();
parsePreferences();

ReactDOM.render((
    <IntlProvider locale={getLocale()} messages={getMessages()} >
        <HashRouter>
            <ErrorBoundary>
                <App/>
            </ErrorBoundary>
        </HashRouter>
    </IntlProvider>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();


// WEBPACK FOOTER //
// ./src/index.js